import { useMemo } from 'react';
import { useSourcesStore } from '@/stores';
import { SourceType } from '@/types/source';

export function useVideoSourceSelected(selected: ReadonlySet<string>): boolean {
    const sourcesMap = useSourcesStore((state) => state.sourcesMap);
    return useMemo(
        () =>
            Array.from(selected).some(
                (id) => sourcesMap.get(id)?.type === SourceType.FILE,
            ),
        [selected, sourcesMap],
    );
}
